import { useEffect, useRef, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import clsx from 'clsx'
import { sendFileMessage } from 'app/redux/messages/messages.actions'
import { DDPlus } from 'app/components/icons'
import './DragAndDropFile.scss'

const getHeaderExpand = ({ widgetData }) => widgetData.widgetInfo.headerExpand
const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts

// DOCUMENT: In case you want to activate the drop-zone on dragging element over an other element,
//           simply change the `id` passed in to 'querySelector' in the 'useEffect'.
//   ====>   The ideal one would be to target the body element to show drop zone area.

function DragAndDropFile() {
  const texts = useSelector(getTexts)
  const headerExpand = useSelector(getHeaderExpand)
  const [zoneActive, setZoneActive] = useState(false)
  const dispatch = useDispatch()
  // To prevent zone flickering due to 'drag leave event' bcz it fires constantly.
  const timerRef = useRef(null)

  const handleDragOver = (e) => {
    e.preventDefault()

    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    setZoneActive(true)
  }

  const handleDrop = (e) => {
    // Prevent default behavior (Prevent file from being opened in the new browser tab)
    e.preventDefault()

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      const item = [...e.dataTransfer.items][0]
      // If dropped items isn't a file, reject it
      if (item.kind === 'file') {
        const file = item.getAsFile()
        dispatch(sendFileMessage(file))
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      const file = [...e.dataTransfer.files][0]
      dispatch(sendFileMessage(file))
    }

    // Clearing zone when any is dropped (either valid or invalid thing)
    // Invalid thing can be text being dropped into the zone!
    setZoneActive(false)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()

    timerRef.current = setTimeout(() => {
      setZoneActive(false)
    }, 15)
  }

  useEffect(() => {
    const messagesContainerElement = document.querySelector('#raychat_messages_container')

    messagesContainerElement.addEventListener('dragover', handleDragOver)
    messagesContainerElement.addEventListener('drop', handleDrop)
    document.addEventListener('dragleave', handleDragLeave)

    return () => {
      messagesContainerElement.removeEventListener('dragover', handleDragOver)

      messagesContainerElement.removeEventListener('drop', handleDrop)

      messagesContainerElement.removeEventListener('dragleave', handleDragLeave)
    }
  }, [])

  return (
    <div
      className={clsx(
        'drag_and_drop_file_input__wrapper',
        'drag_and_drop_file_input',
        headerExpand ? 'header_expand' : 'header_collapse',
        zoneActive ? 'zone_active' : 'zone_inactive',
      )}
      id="drag_and_drop_file_input"
    >
      <div className="drag_and_drop_file_input_plus_box">
        <div className="drag_and_drop_file_input_plus_box_inner">
          <DDPlus className="drag_and_drop_file_input_plus_box_icon" />

          <div className="drag_and_drop_file_input_plus_box__descriptions">
            <p className="drag_and_drop_file_input_plus_box__description">{texts.dragFile}</p>

            <p className="drag_and_drop_file_input_plus_box__descriptions_file_types">
              zip,rar,doxs,note,mp4,jpg,png,gif
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DragAndDropFile
